import axios from "axios";
import {
  SITE_DOCUMENTS_LIST_REQUEST,
  SITE_DOCUMENTS_LIST_SUCCESS,
  SITE_DOCUMENTS_LIST_FAIL,
  SITE_DOCUMENT_UPSERT_REQUEST,
  SITE_DOCUMENT_UPSERT_SUCCESS,
  SITE_DOCUMENT_UPSERT_FAIL,
  SITE_DOCUMENT_DELETE_REQUEST,
  SITE_DOCUMENT_DELETE_SUCCESS,
  SITE_DOCUMENT_DELETE_FAIL,
} from "../constants/siteDocumentConstants";

// GET all documents (public)
export const fetchSiteDocuments = () => async (dispatch) => {
  try {
    dispatch({ type: SITE_DOCUMENTS_LIST_REQUEST });
    const { data } = await axios.get(`/api/site-documents`);
    dispatch({ type: SITE_DOCUMENTS_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SITE_DOCUMENTS_LIST_FAIL,
      payload:
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch documents",
    });
  }
};

// POST upsert by key (client-direct Cloudinary flow)
export const upsertSiteDocument = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: SITE_DOCUMENT_UPSERT_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    const { data } = await axios.post(`/api/site-documents`, payload, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    dispatch({ type: SITE_DOCUMENT_UPSERT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SITE_DOCUMENT_UPSERT_FAIL,
      payload:
        error?.response?.data?.message ||
        error.message ||
        "Failed to save document",
    });
  }
};

// DELETE by id
export const deleteSiteDocument = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SITE_DOCUMENT_DELETE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    await axios.delete(`/api/site-documents/${id}`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    dispatch({ type: SITE_DOCUMENT_DELETE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({
      type: SITE_DOCUMENT_DELETE_FAIL,
      payload:
        error?.response?.data?.message ||
        error.message ||
        "Failed to delete document",
    });
  }
};
